<script>
import { Chrome } from '@lk77/vue3-color';

export default {
  components: {
    Chrome,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      isPickerOpen: false,
      presetGradients: [
        {
          name: 'Blue Gradient',
          value: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        },
        {
          name: 'Green Gradient',
          value: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
        },
        {
          name: 'Ocean Gradient',
          value: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
        },
        {
          name: 'Sunset Gradient',
          value: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
        },
        {
          name: 'Purple Gradient',
          value: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
        },
        {
          name: 'Fire Gradient',
          value: 'linear-gradient(135deg, #ff9a56 0%, #ff6a88 100%)',
        },
      ],
      presetColors: [
        '#000000',
        '#ffffff',
        '#1f93ff',
        '#00c4ad',
        '#7c3aed',
        '#dc2626',
        '#ea580c',
        '#16a34a',
      ],
    };
  },
  methods: {
    closeTogglePicker() {
      if (this.isPickerOpen) {
        this.toggleColorPicker();
      }
    },
    toggleColorPicker() {
      this.isPickerOpen = !this.isPickerOpen;
    },
    updateColor(e) {
      this.$emit('update:modelValue', e.hex);
    },
    selectPresetGradient(gradient) {
      this.$emit('update:modelValue', gradient);
      this.isPickerOpen = false;
    },
    selectPresetColor(color) {
      this.$emit('update:modelValue', color);
      this.isPickerOpen = false;
    },
  },
};
</script>

<template>
  <div class="colorpicker">
    <div
      class="colorpicker--selected"
      :style="
        modelValue.startsWith('linear-gradient')
          ? `background: ${modelValue}`
          : `background-color: ${modelValue}`
      "
      @click.prevent="toggleColorPicker"
    />
    <div
      v-if="isPickerOpen"
      v-on-clickaway="closeTogglePicker"
      class="colorpicker--dropdown"
    >
      <div class="colorpicker--presets">
        <div class="preset-section">
          <p class="preset-title">Gradient Colors</p>
          <div class="preset-grid">
            <div
              v-for="gradient in presetGradients"
              :key="gradient.value"
              class="preset-item gradient"
              :style="`background: ${gradient.value}`"
              :title="gradient.name"
              @click="selectPresetGradient(gradient.value)"
            />
          </div>
        </div>
        <div class="preset-section">
          <p class="preset-title">Solid Colors</p>
          <div class="preset-grid">
            <div
              v-for="color in presetColors"
              :key="color"
              class="preset-item"
              :style="`background-color: ${color}`"
              @click="selectPresetColor(color)"
            />
          </div>
        </div>
      </div>
      <Chrome
        v-if="!modelValue.startsWith('linear-gradient')"
        disable-alpha
        :model-value="modelValue"
        class="colorpicker--chrome"
        @update:model-value="updateColor"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.colorpicker {
  position: relative;
}

.colorpicker--selected {
  @apply border border-solid border-n-weak rounded cursor-pointer h-8 w-8 mb-4;
}

.colorpicker--dropdown {
  @apply shadow-lg -mt-2.5 absolute border border-solid border-n-weak rounded bg-white dark:bg-n-solid-1;
  min-width: 250px;
  z-index: 99999;
}

.colorpicker--presets {
  @apply p-4;
}

.preset-section {
  @apply mb-4;

  &:last-child {
    @apply mb-0;
  }
}

.preset-title {
  @apply text-sm font-medium text-n-slate-12 mb-2;
}

.preset-grid {
  @apply grid grid-cols-6 gap-2;
}

.preset-item {
  @apply w-8 h-8 rounded cursor-pointer border border-solid border-n-weak transition-transform hover:scale-110;

  &.gradient {
    @apply w-full col-span-2;
  }
}

.colorpicker--chrome.vc-chrome {
  @apply shadow-none border-t border-solid border-n-weak rounded-t-none;

  ::v-deep {
    input {
      @apply bg-white dark:bg-white;
    }
  }
}
</style>
